export default {
  InventoryBookMaster: 0,
  InventoryBookMasterAverage: 1,
};
